// extracted by mini-css-extract-plugin
module.exports = {"regularPrice":"index__regularPrice__2k--k","lineThrough":"index__lineThrough__CWHmA","tokensIcon":"index__tokensIcon__2dcef","priceText":"index__priceText__338pR"};